<template>
  <el-card class="box-card contaier">
    <div class="title">
      <span class="perInfo">{{ $t('person.title.info1') }}</span>
      <span class="pro"
        >{{ $t('person.title.info2') }}<i>{{ $t('person.title.info3') }}</i
        >{{ $t('person.title.info4') }}</span
      >
    </div>
    <!-- <div class="main"> -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('person.tabs.tab1')" name="first"><BaseInfo /></el-tab-pane>
      <el-tab-pane :label="$t('person.tabs.tab2')" name="second"><Letter /></el-tab-pane>
      <!-- <el-tab-pane label="调查问卷" name="third"><Quest /></el-tab-pane> -->
      <el-tab-pane :label="$t('person.tabs.tab3')" name="third">
        <span slot="label"> {{ $t('person.tabs.tab3') }}<el-badge :is-dot="badgeMsg"/></span>
        <Quest @func="getMsgFormSon" />
      </el-tab-pane>
      
      <el-tab-pane :label="$t('person.tabs.tab4')" name="fourth"><Group /></el-tab-pane>



      <el-tab-pane :label="$t('person.tabs.tab5')" name="fifth"><Password /></el-tab-pane>
    </el-tabs>
  </el-card>
</template>
<script>
import BaseInfo from './components/baseInfo.vue';
import Letter from './components/confirmLetter.vue';
import Quest from './components/questionnaire.vue';
import Group from './components/group.vue';
import Password from './components/changepassword.vue';
export default {
  data() {
    return {
      activeName: 'first',
      badgeMsg: false, //默认值
    };
  },
  components: {
    BaseInfo,
    Letter,
    Quest,
    Group,
    Password,
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //获取子组件的信息
    getMsgFormSon(data) {
         console.log("11111");
        this.badgeMsg = data;
    },
  },
};
</script>
<style lang="scss" scoped>
.contaier {
  .title {
    display: flex;
    justify-content: flex-start;
    .perInfo {
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
    .pro {
      height: 20px;
      margin-left: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      i {
        font-style: normal;
        color: red;
      }
    }
  }
  // .main {
  //   margin-top: 20px;
  //     .border {
  //     position: absolute;
  //     width: 100%;
  //     height: 1px;
  //     background: #e8e8e8;
  //     left: 0;
  //     top: 39px;
  //   }
  // }
}
</style>
<style scoped>
.el-tabs >>> .el-tabs__item.is-active {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #006fb8;
}
.el-tabs >>> .el-tabs__item:hover {
  color: #006fb8;
  cursor: pointer;
}
.el-tabs >>> .el-tabs__item {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  padding: 0 32px;
}

.el-tabs >>> .el-tabs__nav-wrap::after {
  height: 1px;
  background: #e8e8e8;
}
.el-tabs >>> .el-tabs__nav-wrap::after:hover {
  color: #006fb8;
}

.el-tabs >>> .el-tabs__active-bar {
  height: 2px;
  background-color: #006fb8;
}
</style>
